import React from "react";
import ContactsContainer from "../../containers/contacts/index";
import ContactContainer from "../../containers/contacts/message";
import { useParams } from "react-router-dom";

const ContactsPage = () => {
  let { id } = useParams();

  return id ? <ContactContainer id={id}/> : <ContactsContainer/>
};

export default ContactsPage;
